import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button
} from '@material-ui/core'
import './home.scss'
// import Linkedin from '../../assets/Images/linkedin.png'
// import Medium from '../../assets/Images/medium.png'
// import Instagram from '../../assets/Images/instagram.png'
// import { makeStyles } from '@material-ui/core/styles'
// import DonutChart from "react-donut-chart";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Search, CheckCircle } from '@material-ui/icons'
// import FooterLogo from '../../assets/Images/FooterLogo.png'
import styled from '@emotion/styled'
import { parseSearchTerm } from '../../utils/utils'
import { mediaQueries } from 'devices'
import {
  Body1Bold,
  Body1Medium,
  H2Bold,
  H4Bold,
  SmallText,
  ListText,
  H1Bold,
  H3Bold
} from 'components/Typography/Basic'
// import TokenImage from '../../assets/Images/icon/Frame.png'
import LoveImage from '../../assets/Images/icon/like.png'
import Emoji from '../../assets/Images/icon/Emoji.png'
import QueryAccount from 'components/QueryAccount'
import Loader from 'components/Loader'
import { toast } from 'react-toast'
// import { teamMembers } from './utils'
import ReactPlayer from 'react-player'
import useDarkMode from 'use-dark-mode'
import QueryWrapper from 'components/querywrapper'
import * as qs from 'qs'
import { useFetchPage, useLocale } from 'hooks'
import RedSquare from 'components/RedSquare'
import TeamSection from './TeamSection'

const { REACT_APP_STRAPI_API_URL } = process.env
function Home() {
  const darkmode = useDarkMode()
  const { locale } = useLocale()

  const query = qs.stringify(
    {
      locale: [locale],
      populate: {
        Herosection: {
          populate: {
            mobilecover: {
              fields: ['url']
            },
            cover: {
              fields: ['url']
            },
            button: {
              fields: ['title']
            }
          }
        },
        home_domaininfos: {
          fields: ['name', 'number']
        },
        Norenewal: {
          populate: {
            tokenImage: {
              fields: ['url']
            },
            darkModeTokenImage: {
              fields: ['url']
            }
          }
        },
        Animationsection: {
          populate: {
            logo: {
              fields: ['url']
            },
            Animationfeatures: {
              fields: '*'
            },
            circleimg: {
              fields: ['url']
            }
          }
        },
        Features: {
          populate: ['featuresCards']
        },
        Topleveldomains: {
          populate: {
            image: {
              fields: ['url']
            },
            Features: {
              field: ['title']
            },
            DarkModeImage: {
              fields: ['url']
            }
          }
        },
        Supportedbrowsers: {
          populate: {
            browsers: {
              fields: ['url']
            }
          }
        },
        Utilitysection: {
          populate: {
            image: {
              fields: ['url']
            },
            Features: {
              field: ['title']
            }
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  const fetcher = useCallback(() => {
    return fetch(`${REACT_APP_STRAPI_API_URL}/api/homepage?${query}`).then(
      res => res.json()
    )
  }, [locale, query])
  const { data: page, isLoading: loading, isError: error } = useFetchPage(
    ['api/homepage', locale],
    fetcher
  )

  // const [tableTitles, setTableTitle] = useState()
  // const getTableTitleData = async () => {
  //   const response = await fetch(
  //     `${REACT_APP_STRAPI_API_URL}/api/table-titles`
  //   ).then(response => response.json())
  //   setTableTitle(response?.data)
  // }
  // useEffect(() => {
  //   getTableTitleData()
  // }, [])

  // const [rounds, setRound] = useState()
  // const getRoundData = async () => {
  //   const response = await fetch(
  //     `${REACT_APP_STRAPI_API_URL}/api/home-round-tables`
  //   ).then(response => response.json())
  //   setRound(response?.data)
  // }
  // useEffect(() => {
  //   getRoundData()
  // }, [])

  // const [tokenomics, setTokenomics] = useState()
  // const getTokenomicsData = async () => {
  //   const response = await fetch(
  //     `${REACT_APP_STRAPI_API_URL}/api/home-project-tokenomic-tables`
  //   ).then(response => response.json())
  //   setTokenomics(response?.data)
  // }
  // useEffect(() => {
  //   getTokenomicsData()
  // }, [])

  // ===========>
  const history = useHistory()

  const [inputValue, setInputValue] = useState('')
  //const [filterOpen, setFilterOpen] = useState(false)

  const handleParse = e => {
    setInputValue(e.target.value)
  }
  const hasSearch = inputValue && inputValue.length > 0
  // <============
  const [isLoading, setISLoading] = useState(false)

  return (
    <QueryWrapper loading={loading} error={error}>
      <HeroSection
        cover={
          REACT_APP_STRAPI_API_URL +
          page?.Herosection?.cover?.data?.attributes?.url
        }
        mobilecover={
          REACT_APP_STRAPI_API_URL +
          page?.Herosection?.mobilecover?.data?.attributes?.url
        }
      >
        <Container>
          <H1Bold>{page?.Herosection?.title}</H1Bold>
          <H3Bold className="hero-subtitle">
            {page?.Herosection?.description}
          </H3Bold>
          <Grid>
            <Grid container>
              <div className="domainsearch">
                <QueryAccount>
                  {({ account }) => {
                    return (
                      <div className="search-section">
                        <input
                          type="search"
                          name="domainsearch"
                          value={inputValue}
                          onChange={handleParse}
                          style={{ fontSize: 18 }}
                        />
                        <button
                          disabled={!hasSearch || isLoading}
                          onClick={async () => {
                            if (!hasSearch) return
                            if (account === '0') {
                              toast.error('Please connect Metamask!')
                              return
                            }

                            setISLoading(true)
                            const type = await parseSearchTerm(inputValue)

                            let searchTerm
                            searchTerm = inputValue.toLowerCase()
                            if (!searchTerm || searchTerm.length < 1) {
                              return
                            }

                            if (type === 'address') {
                              history.push(`/address/${searchTerm}`)
                              return
                            }

                            if (type === 'supported' || type === 'short') {
                              history.push(`/name/${searchTerm}/details`)
                              return
                            } else {
                              history.push(`/search/${searchTerm}`)
                            }
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            {!isLoading && <Search />}
                            {page?.Herosection?.button?.title}
                            {isLoading && (
                              <div style={{ marginLeft: 10 }}>
                                <Loader />
                              </div>
                            )}
                          </div>
                        </button>
                      </div>
                    )
                  }}
                </QueryAccount>
              </div>
            </Grid>
          </Grid>
        </Container>
      </HeroSection>

      <section className="bg1">
        <Container>
          <Grid>
            <Grid item xs={12}>
              <div className="domaininfo">
                <ul>
                  {page?.home_domaininfos?.data?.map((domainInfo, id) => (
                    <li key={id}>
                      <>
                        <Typography variant="h4">
                          {domainInfo?.attributes.number}
                        </Typography>
                        <Typography variant="h6">
                          {domainInfo?.attributes.name}
                        </Typography>
                      </>
                    </li>
                  ))}
                </ul>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>
      <WhyDomainWrap>
        <Container>
          <H2Bold className="align-center title gray10 dark-primary">
            {page?.Norenewal?.title}
          </H2Bold>
          <Body1Medium className="align-center light-black dark-primary">
            {page?.Norenewal?.subtitle}
          </Body1Medium>
          <div className="shapebg">
            <Body1Bold className="align-center" style={{ color: '#ffffff' }}>
              {page?.Norenewal?.description1}
            </Body1Bold>
          </div>
          <H4Bold className="navy-blue align-center dark-primary">
            {page?.Norenewal?.description2}
          </H4Bold>
          <div className="token-wrapper">
            <img
              src={
                darkmode.value
                  ? REACT_APP_STRAPI_API_URL +
                    page?.Norenewal?.darkModeTokenImage?.data?.attributes?.url
                  : REACT_APP_STRAPI_API_URL +
                    page?.Norenewal?.tokenImage?.data?.attributes?.url
              }
              alt="token-image"
            />
            <div className="token">
              <SmallText className="black-primary align-center token-text">
                {page?.Norenewal?.token}
              </SmallText>
            </div>
          </div>
        </Container>
      </WhyDomainWrap>
      <WhyDomainFeatures>
        <div className="top-bg background-secondary">
          <div className="top-bg-image">
            <img
              src={
                REACT_APP_STRAPI_API_URL +
                page?.Animationsection?.logo?.data[0]?.attributes?.url
              }
              alt="logo"
              className="img-fluid avax-image"
            />
            <img src={LoveImage} alt="logo" className="img-fluid love-image" />
          </div>
        </div>
        <div className="features-content">
          <div className="animation-img">
            <div className="phone-img-wrapper">
              <div className="black-mask" />
              <div className="black-mask-2" />
              <ReactPlayer
                url={
                  darkmode.value
                    ? 'https://res.cloudinary.com/wweb3/video/upload/v1655319358/AVAX_DARK_z16f3t.mp4'
                    : 'https://res.cloudinary.com/wweb3/video/upload/v1655319352/AVAX_LIGHT_MODE_lrhvgc.mp4'
                }
                playing={true}
                muted={true}
                width="100%"
                height="100%"
                controls={false}
                loop={true}
                playsinline={true}
                className="phone-img"
              />
            </div>
            <div>
              <img
                src={
                  REACT_APP_STRAPI_API_URL +
                  page?.Animationsection.circleimg?.data?.attributes?.url
                }
                alt="animation"
                className="circle-img"
              />
            </div>
          </div>
          <div className="features-list">
            {page?.Animationsection?.Animationfeatures?.map(item => (
              <div key={item.id} className="feature-item">
                <img src={Emoji} alt="emoji" />
                <ListText className="navy-blue dark-primary">
                  {item.title}
                </ListText>
              </div>
            ))}
          </div>
        </div>
      </WhyDomainFeatures>
      <FeaturesWrapper>
        <Container>
          <div className="feature-titles">
            <H2Bold className="align-center light-black dark-primary">
              {page?.Features?.title}
            </H2Bold>
            <H4Bold className="align-center navy-blue-secondary dark-primary">
              {page?.Features?.description}
            </H4Bold>
            <H4Bold className="align-center" style={{ color: '#E7303C' }}>
              {page?.Features?.subtitle}
            </H4Bold>
          </div>
          <Container>
            <CardsWrapper>
              {page?.Features?.featuresCards?.map(feature => (
                <Card key={feature.id} className="background-secondary">
                  <div className="card-details">
                    <div className="card-details-content">
                      <div className="futureliststyleicon">
                        <CheckCircle />
                      </div>
                      <div>
                        <CardTitle className="dark-primary">
                          {feature.title}
                        </CardTitle>
                        <CardContent className="dark-primary">
                          {feature.description}
                        </CardContent>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </CardsWrapper>
          </Container>
        </Container>
      </FeaturesWrapper>

      <TopLevelWrapper>
        <Container>
          <Container className="content">
            <H2Bold>{page?.Topleveldomains?.title}</H2Bold>
            <div className="content-wrapper">
              <ul>
                {page?.Topleveldomains?.Features?.map(domain => (
                  <li key={domain.id}>{domain?.title}</li>
                ))}
              </ul>
              <img
                src={
                  darkmode.value
                    ? REACT_APP_STRAPI_API_URL +
                      page?.Topleveldomains?.DarkModeImage?.data?.attributes
                        ?.url
                    : REACT_APP_STRAPI_API_URL +
                      page?.Topleveldomains?.image?.data?.attributes?.url
                }
                alt="goal"
                className="img-fluid"
              />
            </div>
          </Container>
        </Container>
      </TopLevelWrapper>
      <RedSquare />
      <section className="supported_browser">
        <Container>
          <div className="supported_browserTittle">
            <H2Bold>{page?.Supportedbrowsers?.title}</H2Bold>
          </div>
          <SupportedBrowsers>
            {page?.Supportedbrowsers?.browsers?.data?.map(browser => (
              <img
                key={browser.id}
                src={REACT_APP_STRAPI_API_URL + browser?.attributes?.url}
                alt="browser"
              />
            ))}
          </SupportedBrowsers>
        </Container>
      </section>

      <section className="utilitybox">
        <Container>
          <Grid item xs={12}>
            <div className="utilitybox-title">
              <H2Bold>{page?.Utilitysection?.title}</H2Bold>
            </div>
            <Grid style={{ display: 'flex' }}>
              <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
                <div className="utilitydetails">
                  <div className="utilityinfo">
                    <ul>
                      {page?.Utilitysection?.Features?.map(utility => (
                        <li key={utility.id}>{utility?.title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Grid>
              <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
                <div className="utilityboximage">
                  <img
                    src={
                      REACT_APP_STRAPI_API_URL +
                      page?.Utilitysection?.image.data?.attributes?.url
                    }
                    alt="utility"
                    className="img-fluid"
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </section>
      <TeamSection />
      {/* <section className="teams">
        <Container>
          <div className="teamsBox">
            <H2Bold className="align-center">The Team</H2Bold>
            <section id="features" className="blue">
              <div className="content">
                <div>
                  <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {teamMembers.map((team, id) => (
                      <Grid
                        key={id}
                        container
                        item
                        xl={4}
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                      >
                        <div className="teamsBoxdetails text-center">
                          <div className="teamImagecol">
                            <img
                              src={team?.image}
                              alt="team"
                              className="img-fluid mb-4"
                            />
                          </div>
                          <h5>{team?.name}</h5>
                          <a href="/#" className="mx-3">
                            <img
                              src={Linkedin}
                              alt="linkedin"
                              className="img-fluid"
                            />
                          </a>
                          <a href="/#" className="mx-3">
                            <img
                              src={Medium}
                              alt="medium"
                              className="img-fluid"
                            />
                          </a>
                          <a href="/#" className="mx-3">
                            <img
                              src={Instagram}
                              alt="instagram"
                              className="img-fluid"
                            />
                          </a>
                          <p>{team?.description}</p>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </div>
            </section>
          </div>
        </Container>
      </section> */}

      {/* <div className="roundsBox" style={RoundImg}>
        <Container>
          <div className="roundTittle text-center mb-5">
            <h3 className="mb-0">{titles?.Round}</h3>
          </div>
          <div className="main_table  w-75 m-auto mblwidth100">
            <TableContainer component={Paper}>
              <Table className="table table-striped mb-0  text-center border-0">
                <TableHead>
                  <TableRow>
                    {tableTitles &&
                      tableTitles.map(tableTitle => (
                        <TableCell scope="col" className={classes.bluetext}>
                          {tableTitle?.attributes.title}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rounds &&
                    rounds.map(round => (
                      <TableRow>
                        <>
                          <TableCell scope="row" className={classes.blacktext}>
                            {round?.attributes.name}
                          </TableCell>
                          <TableCell>{round?.attributes.sale}</TableCell>
                          <TableCell>{round?.attributes.seed}</TableCell>
                          <TableCell>{round?.attributes.private1}</TableCell>
                          <TableCell>{round?.attributes.private2}</TableCell>
                          <TableCell>{round?.attributes.publicsale}</TableCell>
                        </>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Container>
      </div>
      <section className="project_token">
        <Container>
          <div className="roundTittle text-center mb-5">
            <h3 className="mb-0">{titles?.ProjectToken}</h3>
          </div>
          <div className="main_table mb-3 w-75 m-auto mblwidth100">
            <TableContainer component={Paper}>
              <Table className="table mb-0 table-striped text-center border-0">
                <TableHead>
                  <TableRow className="border-0">
                    {tableTitles &&
                      tableTitles.map(tableTitle => (
                        <TableCell scope="col" className={classes.bluetext}>
                          {tableTitle?.attributes.title1}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody className="tokentable">
                  {tokenomics &&
                    tokenomics.map(tokenomic => (
                      <TableRow>
                        <>
                          <TableCell scope="row" className={classes.blacktext1}>
                            {tokenomic?.attributes.category}
                          </TableCell>
                          <TableCell>
                            {tokenomic?.attributes.allocation}
                          </TableCell>
                          <TableCell>{tokenomic?.attributes.price}</TableCell>
                          <TableCell>{tokenomic?.attributes.token}</TableCell>
                          <TableCell>{tokenomic?.attributes.lockup}</TableCell>
                          <TableCell>{tokenomic?.attributes.vesting}</TableCell>
                        </>
                      </TableRow>
                    ))}
                  <TableRow>
                    <TableCell colSpan={6}>
                      <div className="pinklabel">
                        <span className="pinktext">{titles?.marketcap}</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div className="tablebottombg" />
        </Container>
      </section>
      <section className="chart_tokens">
        <div className="chartTittle mb-5">
          <h3>{titles?.Graph}</h3>
        </div>
        <DonutChart
                    data={[
                        {
                            label: "Team",
                            value: 12.5
                        },
                        {
                            label: "Community enrichment wallet",
                            value: 20
                        },
                        {
                            label: "Operations",
                            value: 5
                        },
                        {
                            label: "Marketing",
                            value: 5
                        },
                        {
                            label: "Advisors",
                            value: 4
                        },
                        {
                            label: "Pre seeds sale",
                            value: 6
                        },
                        {
                            label: "Staking / Early  Incentive Reward ",
                            value: 20
                        },
                        {
                            label: "Seeds sale",
                            value: 7
                        },
                        {
                            label: "Private 1 ",
                            value: 6.5
                        },
                        {
                            label: "Public Sale",
                            value: 3
                        },
                        {
                            label: "Private 2",
                            value: 7
                        },
                    ]}
                />
      </section> */}
    </QueryWrapper>
  )
}

export default Home

const HeroSection = styled('div')`
  background: ${({ cover }) => `url(${cover})`};
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 100px;
  padding-bottom: 135px;
  min-height: 712px;
  overflow-x: hidden;
  ${mediaQueries.tabport} {
    background-position: center;
  }
  ${mediaQueries.phone} {
    background: ${({ mobilecover }) => `url(${mobilecover})`};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 611px;
    padding-top: 80px;
  }
  .hero-subtitle {
    color: #e7303c;
  }
  .domainsearch {
    width: 100%;
    ${mediaQueries.phone} {
      margin-top: 50px;
    }
  }
`

const WhyDomainFeatures = styled.div`
  position: relative;
  margin-top: 120px;
  ${mediaQueries.phone} {
    margin-top: 80px;
  }
  .features-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    ${mediaQueries.phone} {
      flex-direction: column-reverse;
    }
    .features-list {
      ${mediaQueries.tabport} {
        margin: 120px 0px;
      }
      ${mediaQueries.phone} {
        margin: 40px 0px;
      }
    }
    .feature-item {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      ${mediaQueries.phone} {
        padding: 0px 20px;
      }
      img {
        margin-right: 10px;
        max-width: 35px;
        height: auto;
        ${mediaQueries.phone} {
          max-width: 25px;
        }
      }
    }
  }
  .animation-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    max-width: 450px;

    .phone-img-wrapper {
      position: relative;
      max-width: 56%;
    }

    .black-mask {
      position: absolute;
      width: 24.6%;
      height: 62px;
      top: 0px;
      left: 0px;
      margin: 0em auto;
      background-image: radial-gradient(
        circle at 0 100%,
        transparent 0%,
        transparent 62px,
        black 62px
      );
      transform: rotate(-90deg);
      ${mediaQueries.phone} {
        display: none;
      }
    }
    .black-mask-2 {
      position: absolute;
      width: 24.8%;
      height: 62px;
      top: 0px;
      right: 0px;
      margin: 0em auto;
      background-image: radial-gradient(
        circle at 0 100%,
        transparent 0%,
        transparent 62px,
        black 62px
      );
      ${mediaQueries.phone} {
        display: none;
      }
    }
    .phone-img {
      max-width: 100%;
      height: auto;
      border-radius: 20px;
    }
    .circle-img {
      max-width: 100%;
      height: auto;
    }
  }
  .top-bg {
    position: absolute;
    z-index: -1;
    width: 100%;
    background: black;
    padding: 24px;
    padding-left: 56.04%;
    ${mediaQueries.phone} {
      position: relative;
      padding: 24px;
    }
    .top-bg-image {
      .avax-image {
        position: relative;
        ${mediaQueries.phone} {
          max-width: 60%;
        }
      }
      .love-image {
        position: absolute;
        bottom: 50%;
      }
    }
  }
`

const WhyDomainWrap = styled.div`
  margin-top: 200px;
  ${mediaQueries.phone} {
    margin-top: 100px;
  }
  .title {
    margin-bottom: 22px;
  }
  .shapebg {
    padding: 35px 20px;
    margin-top: 38px;
    margin-bottom: 85px;
  }
  .token-wrapper {
    position: relative;
    height: 126px;
    max-width: 584px;
    margin: auto;
    margin-top: 22px;
    display: grid;
    place-items: center;
    ${mediaQueries.phone} {
      .token-text {
        word-break: break-all;
      }
      max-width: 100%;
    }
    .token {
      border: 1px solid #000000;
      background: white;
      padding: 20px;
      margin: auto;
      padding-left: 25.6%;
      box-sizing: border-box;
      ${mediaQueries.phone} {
        padding: 10px;
        padding-left: 10%;
        width: 100%;
      }
    }
    img {
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
      max-width: 22%;
      height: auto;
      ${mediaQueries.phone} {
        max-width: 10%;
      }
    }
  }
`

const FeaturesWrapper = styled.div`
  margin-top: 200px;
  .feature-titles {
    max-width: 900px;
    margin: auto;
    > * {
      margin-bottom: 70px;
    }
  }
  ${mediaQueries.phone} {
    margin-top: 100px;
    > * {
      margin-bottom: 40px;
    }
  }
`
const TopLevelWrapper = styled.div`
  margin-top: 164px;
  .content-wrapper {
    display: flex;
    margin-top: 87px;
    ${mediaQueries.tabport} {
      padding-left: 20px;
    }
    ${mediaQueries.phone} {
      margin-top: 20px;
    }
    img {
      max-width: 50%;
      height: auto;
      ${mediaQueries.tabport} {
        max-width: 50%;
      }
      ${mediaQueries.phone} {
        max-width: 100%;
        margin-top: 60px;
      }
    }
    ul {
      padding-left: 40px;
      ${mediaQueries.phone} {
        padding-left: 0px;
      }
      li {
        font-size: 22px;
        align-items: center;
        margin-top: 40px;
        font-weight: 600;
        font-family: 'Poppins';
        ${mediaQueries.phone} {
          margin-top: 34px;
          font-size: 20px;
        }
      }
    }
    ${mediaQueries.phone} {
      flex-direction: column;
      gap: 10px;
      padding-left: 20px;
    }
  }
`

const Knowmorewrapper = styled.div`
  background: #1445d7;
  padding-top: 86px;
  margin-top: 148px;
  height: 172px;
  margin-bottom: 350px;
  ${mediaQueries.phone} {
    margin-bottom: 400px;
    margin-top: 50px;
  }
  .knowmorecontent {
    max-width: 900px;
    padding: 43px;
    padding-top: 53px;
    padding-bottom: 53px;
    overflow: hidden;
    margin: auto;
    background: #e7303c;
    ${mediaQueries.tabport} {
      width: 100%;
    }
    ${mediaQueries.phone} {
      padding-bottom: 50px;
    }
    @media (min-width: 2000px) {
      width: 50%;
    }
    .text {
      text-align: justify;
      ${'' /* max-width: 81.6%; */}
      color: #ffffff;
      font-size: 28px;
      font-weight: 700;
      font-family: 'Roboto', sans-serif;
      ${mediaQueries.tabport} {
        text-align: left;
        max-width: 100%;
      }
    }
  }
  .knowmorebtn-wrapper {
    ${'' /* max-width: 80%; */}
    ${mediaQueries.tabport} {
      max-width: 100%;
    }
  }
  button {
    float: right;
    ${mediaQueries.tabport} {
      float: none;
    }
  }
  ${mediaQueries.tabport} {
    padding: 48px 40px;
  }
  ${mediaQueries.phone} {
    padding: 48px 10px;
    margin-top: 60px;
  }
`

const CardTitle = styled('h4')`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.25px;
  color: #000000;
  margin-bottom: 11px;
  ${mediaQueries.phone} {
    font-size: 14px;
  }
`

const CardContent = styled('p')`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  margin-top: 0;
  margin-bottom: 10px;
  ${mediaQueries.phone} {
    font-size: 11px;
  }
`

const Card = styled.div`
  padding: 50px 30px;
  border: 1px solid black;
  ${'' /* background: ${({ theme }) => theme.colors.background3}; */}
  box-sizing: border-box;
  svg {
    width: 60px;
    height: auto;
    flex-shrink: 0;
    align-self: flex-start;
  }
  .futureliststyleicon {
    align-self: center;
    height: 100%;
  }
  .card-details {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    .card-details-content {
      display: flex;
      gap: 10px;
      justify-content: center;
    }
  }
  ${mediaQueries.phone} {
    padding: 20px;
  }
  ${mediaQueries.phone} {
    svg {
      width: 40px;
      height: auto;
    }
  }
`

const CardsWrapper = styled.div`
  display: Grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 35px;
  ${mediaQueries.tabport} {
    padding: 0px;
  }
  ${mediaQueries.phone} {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-auto-rows: 1fr;
  }
`
const SupportedBrowsers = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 43.5px;
  ${mediaQueries.phone} {
    gap: 6px;
    img {
      max-width: 45px;
      height: auto;
    }
  }
`
